import { render } from "./authoring-conversation.vue?vue&type=template&id=16264c17&scoped=true"
import script from "./authoring-conversation.vue?vue&type=script&lang=js"
export * from "./authoring-conversation.vue?vue&type=script&lang=js"

import "./authoring-conversation.vue?vue&type=style&index=0&id=16264c17&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16264c17"]])

export default __exports__